<template>
    <div class="sign-up flex center column">
        <div>
            <h1 class="su-title">Sign Up</h1>
        </div>
        <re-form></re-form>
    </div>
</template>

<script>
    import Form from '../Form.vue'

    export default {
        components: {
            're-form': Form
        }
    }
</script>

<style scoped>
    .re-form{
        margin: 0;
    }

    .sign-up {
        height: 556px;
        margin: auto;
        background-image: url(../../assets/Desktop/About_Us/sign_up_img.jpg);
    }

    .su-title {
        color: #FFFFFF;
        font-family: Trirong;
        font-size: 40px;
        font-weight: 800;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/Sign_Up.vue